export namespace MediaQueries {
  export const LARGE_DESK_SCREEN = 'screen and (min-width: 1200px)';
  export const MEDIUM_DESK_SCREEN = 'screen and (min-width: 1024px) and (max-width: 1199px)';
  export const TABLET_SCREEN = 'screen and (min-width: 768px) and (max-width: 1023px)';
  export const TABLET_MAX = '(max-width: 1023px)';
  export const LARGE_MOBILE_SCREEN = 'screen and (min-width: 376px) and (max-width: 767px)';
  export const MOBILE_SCREEN = 'screen and (max-width: 767px)';

  export const mediaSmallDesk = `@media ${MEDIUM_DESK_SCREEN}`;
  export const mediaSmallDeskMax = '@media screen and (max-width: 1199px)';
  export const mediaTablet = `@media ${TABLET_SCREEN}`;
  export const mediaMobile = `@media ${MOBILE_SCREEN}`;
  export namespace Picture {
    export const mobile = 'only screen and (max-width: 767px)';
    export const mobileX2 = `
      only screen and (-webkit-min-device-pixel-ratio: 2)      and (max-width: 767px),
      only screen and (   min--moz-device-pixel-ratio: 2)      and (max-width: 767px),
      only screen and (     -o-min-device-pixel-ratio: 2/1)    and (max-width: 767px),
      only screen and (        min-device-pixel-ratio: 2)      and (max-width: 767px),
      only screen and (                min-resolution: 192dpi) and (max-width: 767px),
      only screen and (                min-resolution: 2dppx)  and (max-width: 767px)
    `;

    const tabletMinWidth = 768;
    const tabletMaxWidth = 1023;
    export const tablet = getMedia({ min: tabletMinWidth, max: tabletMaxWidth });
    export const tabletX2 = getMediaX2({ min: tabletMinWidth, max: tabletMaxWidth });

    const mediumMinWidth = 1024;
    const mediumMaxWidth = 1199;
    export const medium = getMedia({ min: mediumMinWidth, max: mediumMaxWidth });
    export const mediumX2 = getMediaX2({ min: mediumMinWidth, max: mediumMaxWidth });

    const largeMinWidth = 1200;
    export const large = `only screen and (min-width: ${largeMinWidth}px)`;
    export const largeX2 = `
      only screen and (-webkit-min-device-pixel-ratio: 2)      and (min-width: ${largeMinWidth}px),
      only screen and (   min--moz-device-pixel-ratio: 2)      and (min-width: ${largeMinWidth}px),
      only screen and (     -o-min-device-pixel-ratio: 2/1)    and (min-width: ${largeMinWidth}px),
      only screen and (        min-device-pixel-ratio: 2)      and (min-width: ${largeMinWidth}px),
      only screen and (                min-resolution: 192dpi) and (min-width: ${largeMinWidth}px),
      only screen and (                min-resolution: 2dppx)  and (min-width: ${largeMinWidth}px),
    `;

    /* eslint-disable no-inner-declarations */
    function getMedia({ min, max }: { min: number; max: number }) {
      return `only screen and (min-width: ${min}px) and (max-width: ${max}px)`;
    }

    function getMediaX2({ min, max }: { min: number; max: number }) {
      return `
        only screen and (-webkit-min-device-pixel-ratio: 2)      and (min-width: ${min}px) and (max-width: ${max}px),
        only screen and (   min--moz-device-pixel-ratio: 2)      and (min-width: ${min}px) and (max-width: ${max}px),
        only screen and (     -o-min-device-pixel-ratio: 2/1)    and (min-width: ${min}px) and (max-width: ${max}px),
        only screen and (        min-device-pixel-ratio: 2)      and (min-width: ${min}px) and (max-width: ${max}px),
        only screen and (                min-resolution: 192dpi) and (min-width: ${min}px) and (max-width: ${max}px),
        only screen and (                min-resolution: 2dppx)  and (min-width: ${min}px) and (max-width: ${max}px),
      `;
    }
    /* eslint-enable no-inner-declarations */
  }
}
